module.exports = __webpack_public_path__ + "static/img/joinUs_02.e0993166.jpg";